// @flow
import createAction from 'Store/utils/createAction';

import { ROUTING_CHANGE } from './constants';

export default function routingChange(): RoutingChange {
  return createAction(ROUTING_CHANGE, {});
}
